import React from 'react';

type SocioEconomicProps = {
    socioEconomic: any;
}

const SocioEconomicComponent: React.FunctionComponent<SocioEconomicProps> = ({ socioEconomic }: SocioEconomicProps) => {
    return (
        <>
            <p className="m-0 fw-bold text-dark">Quantas pessoas moram com você incluindo filhos, irmãos, parentes e amigos?</p>
            <p className="m-0">{socioEconomic.howManyPeopleLiveWithYou || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Qual é a renda total somando a sua renda com a renda das pessoas que moram com você?</p>
            <p className="m-0">{socioEconomic.totalIncomeAddedTogether || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Quantas pessoas trabalham na sua casa?</p>
            <p className="m-0">{socioEconomic.howManyPeopleWorkInYourHome || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Qual a situação familiar?</p>
            <p className="m-0">{socioEconomic.whatIsYourFamilySituation || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Você possui filhos?</p>
            <p className="m-0">{socioEconomic.youHaveChildren ? 'Sim' : 'Não'}</p>

            <p className="m-0 fw-bold text-dark">Qual seu tipo de moradia?</p>
            <p className="m-0">{socioEconomic.whatTypeOfHousingDoYouHave || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Hoje você possui renda própria?</p>
            <p className="m-0">{socioEconomic.youHaveYourOwnIncome ? 'Sim' : 'Não'}</p>

            <p className="m-0 fw-bold text-dark">Você se enquadra em alguma medida socioeducativa?</p>
            <p className="m-0">{socioEconomic.doYouQualifyForAnySocioEducationalMeasure ? 'Sim' : 'Não'}</p>

            <p className="m-0 fw-bold text-dark">Sua família está inscrita no Cad. Único?</p>
            <p className="m-0">{socioEconomic.yourFamilyIsRegisteredWithCAD ? 'Sim' : 'Não'}</p>

            {socioEconomic.yourFamilyIsRegisteredWithCAD && (
                <>
                    <p className="m-0 fw-bold text-dark">Qual o seu código familiar?</p>
                    <p className="m-0">{socioEconomic.whatIsYourFamilyCode}</p>
                </>
            )}
        </>
    );
};

type RedeCidadaProps = {
    redeCidada: any;
}

const RedeCidadaComponent: React.FunctionComponent<RedeCidadaProps> = ({ redeCidada }: RedeCidadaProps) => {
    return (
        <>
            <p className="m-0 fw-bold text-dark">Como conheceu a Rede Cidadã?</p>
            <p className="m-0">{redeCidada.howDidYouFindOutAboutTheRedeCidada || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Você conheceu a Rede Cidadã através de alguma das instituições abaixo?</p>
            <p className="m-0">{redeCidada.didYouFindOutAboutRedeCidadaThroughOneOfTheInstitutionsBelow || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Nome da Instituição Parceira?</p>
            <p className="m-0">{redeCidada.nameOfPartnerInstitution || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Você já foi Jovem Aprendiz?</p>
            <p className="m-0">{redeCidada.haveYouEverBeenAYoungApprentice ? 'Sim' : 'Não'}</p>

            <p className="m-0 fw-bold text-dark">Já trabalhou com carteira assinada?</p>
            <p className="m-0">{redeCidada.haveYouEverWorkedWithASignedContract ? 'Sim' : 'Não'}</p>

            {redeCidada.haveYouEverWorkedWithASignedContract && (
                <>
                    <p className="m-0 fw-bold text-dark">Se sim, qual sua última função?</p>
                    <p className="m-0">{redeCidada.whatIsYourLastFunction}</p>
                </>
            )}

            <p className="m-0 fw-bold text-dark">Qual o número da sua Carteira de Trabalho / CTPS? (Em caso de Digital, digite os 07 primeiros dígitos do CPF)</p>
            <p className="m-0">{redeCidada.whatIsYourWorkCard || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Série (Em caso de Digital, 04 primeiros dígitos do CPF)</p>
            <p className="m-0">{redeCidada.whatIsTheSeriesOfYourWorkCard || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Nome da Mãe</p>
            <p className="m-0">{redeCidada.mothersName || 'Não informado'}</p>

            <p className="m-0 fw-bold text-dark">Telefone do responsável</p>
            <p className="m-0">{redeCidada.mothersCellphoneNumber || 'Não informado'}</p>
        </>
    );
};

export {
    SocioEconomicComponent,
    RedeCidadaComponent
};